import React, { useState } from 'react';
import { Button, Typography } from '@mui/material';

import { useOnboarding } from '../../../data-access';
import { ONBOARDING_PATH } from '../../../routing';
import {
  ConnectionsState,
  PowerUpPlanConnections,
  PowerUpPlanPreferences,
  PowerUpPlanQualityDots,
  PowerUpPlanWeekPreview,
} from '../../../components/Onboarding';
import LifestackLogoName from '../../../assets/logo/new_logo_with_name.png';
import './PowerUpPlanPage.scss';
import '../ConnectWorldPage/ConnectWorldPage.scss';
import '../QuickPrefPage/QuickPrefPage.scss';
import '../WorkPrefPage/WorkPrefPage.scss';
import '../../../components/Onboarding/OnboardingWrapper/OnboardingWrapper.scss';

const PowerUpPlanPage: React.FC = () => {
  const { currentOnboardingStep, goToNextStep } = useOnboarding();

  const [hasCalendar, setHasCalendar] = useState(false);
  const [hasTodos, setHasTodos] = useState(false);
  const [hasHealth, setHasHealth] = useState(false);

  const redirectTo = ONBOARDING_PATH[currentOnboardingStep?.key || 'POWER_UP_PLAN'];
  const qualityDots = Math.min(
    5,
    1 + (hasCalendar ? 2 : 0) + (hasTodos ? 1 : 0) + (hasHealth ? 1 : 0)
  );

  const handleConnectionsChange = ({
    hasCalendar: c,
    hasTodos: t,
    hasHealth: h,
  }: ConnectionsState) => {
    setHasCalendar(c);
    setHasTodos(t);
    setHasHealth(h);
  };

  return (
    <div className="power-up-plan-page">
      <header className="power-up-plan-page__header">
        <img src={LifestackLogoName} alt="Lifestack" className="power-up-plan-page__logo" />
      </header>

      <main className="power-up-plan-page__body">
        <PowerUpPlanWeekPreview
          calendarOn={hasCalendar}
          wearableOn={hasHealth}
          todosOn={hasTodos}
        />

        <section className="power-up-plan-page__card">
          <h1 className="power-up-plan-page__title">Power up your plan</h1>
          <p className="power-up-plan-page__sub">
            More data = smarter schedule. Connect what you can. You can set up these anytime in
            Settings.
          </p>

          <PowerUpPlanQualityDots filledCount={qualityDots} />

          <Typography variant="overline" className="power-up-plan-page__section-label">
            Integrations
          </Typography>
          <div className="power-up-plan-page__conn-section">
            <PowerUpPlanConnections
              redirectTo={redirectTo}
              onConnectionsChange={handleConnectionsChange}
            />
          </div>

          <Typography variant="overline" className="power-up-plan-page__section-label">
            Daily preferences
          </Typography>
          <PowerUpPlanPreferences />

          <Button
            variant="contained"
            className="onboarding-wrapper__button"
            onClick={() => {
              goToNextStep();
            }}
            fullWidth
            style={{ marginTop: 40 }}
          >
            Build my plan
          </Button>
        </section>
      </main>
    </div>
  );
};

export default PowerUpPlanPage;
